import {useMediaQuery} from 'react-responsive';

const useBreakpointXL = (): boolean => useMediaQuery({minWidth: 1200});

export default useBreakpointXL;
